import { jsx as f } from "react/jsx-runtime";
import { c as g } from "../../../index-Cu0xwYjD.js";
import { s as r } from "../../../Grid.module-BpY5QcAG.js";
import { MAX_COLS as t } from "./Row.js";
const L = ({
  children: l,
  className: m,
  style: i,
  small: o,
  medium: s,
  large: c,
  ...a
}) => {
  const n = o && o <= t ? o : t, p = s && s <= t ? s : n, d = c && c <= t ? c : p;
  return /* @__PURE__ */ f(
    "div",
    {
      style: {
        "--grid-col-span-sm": n,
        "--grid-col-span-md": p,
        "--grid-col-span-lg": d,
        ...i
      },
      className: g(r.col, {
        [r.small]: !!o,
        [r.medium]: !!s,
        [r.large]: !!c,
        className: m
      }),
      ...a,
      children: l
    }
  );
};
export {
  L as Col
};
